import type { LegacyReportCropInput } from "../types/legacyReportReview";

export interface LegacyCropPoint {
  x: number;
  y: number;
}

export interface LegacyCropPageSize {
  width: number;
  height: number;
}

export function sourcePagePoint(
  point: LegacyCropPoint,
  bounds: { left: number; top: number; width: number; height: number },
  page: LegacyCropPageSize
): LegacyCropPoint | null {
  if (bounds.width <= 0 || bounds.height <= 0) return null;
  return {
    x: Math.max(
      0,
      Math.min(
        page.width,
        ((point.x - bounds.left) / bounds.width) * page.width
      )
    ),
    y: Math.max(
      0,
      Math.min(
        page.height,
        ((point.y - bounds.top) / bounds.height) * page.height
      )
    ),
  };
}

export function sourceCropRegion(
  first: LegacyCropPoint,
  second: LegacyCropPoint,
  page: LegacyCropPageSize
): LegacyReportCropInput["region"] {
  const x = Math.max(0, Math.floor(Math.min(first.x, second.x) * 10) / 10);
  const y = Math.max(0, Math.floor(Math.min(first.y, second.y) * 10) / 10);
  const right = Math.min(
    page.width,
    Math.ceil(Math.max(first.x, second.x) * 10) / 10
  );
  const bottom = Math.min(
    page.height,
    Math.ceil(Math.max(first.y, second.y) * 10) / 10
  );
  return {
    x,
    y,
    width: Number((right - x).toFixed(2)),
    height: Number((bottom - y).toFixed(2)),
  };
}

export function isSourceCropWithinPage(
  region: LegacyReportCropInput["region"],
  page: LegacyCropPageSize
) {
  return (
    Object.values(region).every(Number.isFinite) &&
    region.x >= 0 &&
    region.y >= 0 &&
    region.width > 0 &&
    region.height > 0 &&
    region.x + region.width <= page.width &&
    region.y + region.height <= page.height
  );
}
